import { render, staticRenderFns } from "./tipositem.vue?vue&type=template&id=737fbfa5"
import script from "./tipositem.vue?vue&type=script&lang=js"
export * from "./tipositem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports